export default __webpack_public_path__ + "static/media/orange-svtv-tick.dfc719d1.svg";